import styled from 'styled-components';
import { color, typography } from 'styles/settings';
import { withModifiers } from 'utils';
import ErrorMessageComponent from 'components/error-message';

export const textEditorClassName = 'text-editor';

export const ErrorMessage = styled(ErrorMessageComponent)``;

export const Container = styled.div`
  position: relative;
  height: 70%;
  width: auto;
  z-index: 2;
  margin-top: 10px;

  ${typography.font.content.regular};
  font-size: ${typography.size.md};
  letter-spacing: -0.32px;

  .${textEditorClassName} {
    height: 100%;
    width: 99%;
  }

  ${withModifiers('$invalid')`
        border: 1px solid ${color.ui.danger};
  `};

  ::selection {
    background-color: ${color.brand.gold};
    color: ${color.neutral.white};
  }
`;

export const Leaf = styled.span`
  ${withModifiers('highlight')`
        background-color: ${color.brand.goldWithOpacity(0.3)};
    `}

  ${withModifiers('highlight', '$isNote')`
        background-color: ${color.neutral.white};
    `}

  ${withModifiers('strikethrough')`
        text-decoration: line-through;
    `}

    ${withModifiers('underline')`
        text-decoration: underline;
    `}

    ${withModifiers('strikethrough', 'underline')`
        text-decoration: line-through underline;
    `}

    ${withModifiers('isSelected')`
      span[data-slate-string="true"] {
        color: ${color.neutral.white};
        background-color: ${color.brand.gold};
        ${withModifiers('inNote')`
            background-color: ${color.neutral.plainBlack};
        `}
      }
    `}
`;
